<script setup lang="ts">
import { computed } from "vue";
import { useRoute, RouterView } from "vue-router";
import AppShell from "@/components/AppShell.vue";
import ConfirmDialog from "@/components/ui/ConfirmDialog.vue";
import { pageLoadFailure, retryPageLoad } from "@/lib/chunkRecovery";

const route = useRoute();
const isPublic = computed(() => route.meta.public === true);
</script>

<template>
  <div v-if="pageLoadFailure" class="page-load-failure" role="alert">
    <span>This page couldn't load, even after refreshing. Check your connection, then retry.</span>
    <button type="button" class="btn btn--sm" @click="retryPageLoad()">Retry</button>
  </div>
  <RouterView v-if="isPublic" />
  <AppShell v-else>
    <RouterView />
  </AppShell>
  <ConfirmDialog />
</template>

<style scoped>
.page-load-failure {
  position: fixed; z-index: 100; top: var(--space-3); left: 50%; transform: translateX(-50%);
  display: flex; align-items: center; gap: var(--space-3); max-width: calc(100vw - 32px);
  padding: var(--space-2) var(--space-3); border-radius: var(--radius-s);
  background: var(--bg-elev); color: var(--ink); border: 1px solid var(--danger);
  box-shadow: 0 6px 24px rgb(0 0 0 / 0.18); font-size: 0.875rem;
}
</style>
